<template>
  <a-drawer
    :title="title"
    :width="drawerWidth"
    @close="handleCancel"
    :visible="visible"
    :wrapStyle="{ height: 'calc(100% - 0px)', overflow: 'auto', paddingBottom: '0px' }"
  >
    <div :style="{ width: '100%', padding: '10px 16px', background: '#fff' }">
      <a-spin :spinning="loading">
        <a-form :form="form" @keyup.enter.native="handleOk">
          <a-form-item :label="$t('disp.menuType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group @change="onChangeMenuType" v-decorator="['menuType', { initialValue: localMenuType }]">
              <a-radio :value="0" :disabled="localMenuType != 0">{{ $t('disp.menuType.root') }}</a-radio>
              <a-radio :value="1" :disabled="localMenuType != 1">{{ $t('disp.menuType.page') }}</a-radio>
              <a-radio :value="2" :disabled="localMenuType != 2">{{ $t('disp.menuType.element') }}</a-radio>
            </a-radio-group>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.menuName')">
            <a-tooltip placement="topLeft">
              <template slot="title">
                {{
                  locales
                    .map((locale) => {
                      return currentLocale['text_' + locale.value] + $t('disp.menuName')
                    })
                    .join(';')
                }}
              </template>
              <a-input
                :placeholder="$t('disp.ph.input', [$t('disp.menuName')])"
                v-decorator="['name', validatorRules.name]"
                :readOnly="disableSubmit"
                :maxLength="100"
              />
            </a-tooltip>
          </a-form-item>

          <a-form-item
            v-show="localMenuType != 0"
            :label="$t('disp.parentMenu')"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :validate-status="validateStatus"
            :required="true"
          >
            <a-tree-select
              style="width: 100%"
              :dropdownStyle="{ maxHeight: 'calc(100vh - 300px)', overflow: 'auto' }"
              :treeData="treeData"
              v-model="model.parentId"
              :placeholder="$t('disp.ph.input', [$t('disp.parentMenu')])"
              :disabled="disableSubmit"
              @change="handleParentIdChange"
            ></a-tree-select>
          </a-form-item>

          <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.browserUrl')">
            <a-input
              :placeholder="$t('disp.ph.input', [$t('disp.browserUrl')])"
              v-decorator="['url', validatorRules.url]"
              :readOnly="disableSubmit"
              :maxLength="255"
            />
          </a-form-item>

          <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.component')">
            <a-input
              :placeholder="$t('disp.ph.input', [$t('disp.component')])"
              v-decorator="['component', validatorRules.component]"
              :readOnly="disableSubmit"
              :maxLength="255"
            />
          </a-form-item>

          <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用开始日">
            <a-date-picker placeholder="请选择使用开始日" style="width: 100%" v-decorator="['startDate', {}]" />
          </a-form-item>

          <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用结束日">
            <a-date-picker placeholder="请选择使用结束日" style="width: 100%" v-decorator="['endDate', {}]" />
          </a-form-item>

          <!-- <a-form-item
            v-show="localMenuType==0"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="默认跳转地址"
          >
            <a-input
              placeholder="请填写路由参数 redirect"
              v-decorator="[ 'redirect',{}]"
              :readOnly="disableSubmit"
            />
          </a-form-item>-->

          <a-form-item
            v-show="!show"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="$t('disp.perms')"
          >
            <a-input
              :placeholder="$t('disp.perms.ph')"
              v-decorator="['perms', validatorRules.perms]"
              :readOnly="disableSubmit"
              :maxLength="255"
            />
          </a-form-item>

          <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.menuIcon')">
            <a-input
              :placeholder="$t('disp.ph.select', [$t('disp.menuIcon')])"
              v-model="model.icon"
              :readOnly="disableSubmit"
              :maxLength="100"
            >
              <a-icon slot="addonAfter" type="setting" @click="selectIcons" />
            </a-input>
          </a-form-item>

          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.sort')">
            <j-input-number
              style="width: 80px"
              v-decorator="['sortNo', validatorRules.sortNo]"
              :readOnly="disableSubmit"
              :min="0"
              :max="999"
              :required="true"
            />
          </a-form-item>

          <!-- <a-form-item
            v-show="show"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="$t('disp.routeSwitch')"
          >
            <a-switch
              :checkedChildren="$t('disp.yes')"
              :unCheckedChildren="$t('disp.no')"
              v-model="routeSwitch"
            />
          </a-form-item>-->

          <!-- <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" label="隐藏路由">
            <a-switch :checkedChildren="$t('disp.yes')" :unCheckedChildren="$t('disp.no')" v-model="menuHidden" />
          </a-form-item>-->

          <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据过滤">
            <a-switch checkedChildren="有" unCheckedChildren="无" v-model="dataFilter" />
          </a-form-item>

          <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.isKeepalive')">
            <a-switch :checkedChildren="$t('disp.yes')" :unCheckedChildren="$t('disp.no')" v-model="keepAlive" />
          </a-form-item>

          <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.alwaysShow')">
            <a-switch :checkedChildren="$t('disp.yes')" :unCheckedChildren="$t('disp.no')" v-model="alwaysShow" />
          </a-form-item>

          <!-- <a-form-item v-show="show" :labelCol="labelCol" :wrapperCol="wrapperCol" label="打开方式">
            <a-switch checkedChildren="外部" unCheckedChildren="内部" v-model="internalOrExternal" />
          </a-form-item>-->
        </a-form>

        <!-- iconを選択 -->
        <icons @choose="handleIconChoose" @close="handleIconCancel" :iconChooseVisible="iconChooseVisible"></icons>
      </a-spin>

      <a-divider style="margin: 20px 0px 10px"></a-divider>

      <a-row :style="{ textAlign: 'right' }">
        <a-button :disabled="disableSubmit" @click="handleOk" type="primary" icon="check">{{
          $t('disp.btn.confirm')
        }}</a-button>
      </a-row>
    </div>
  </a-drawer>
</template>

<script>
import { addPermission, editPermission, queryTreeList, duplicateCheck } from '@/api/api'
import Icons from './icon/Icons'
import pick from 'lodash/pick'
import JInputNumber from '@/components/JInputNumber'

export default {
  name: 'MenuModal',
  components: { Icons, JInputNumber },
  data() {
    return {
      drawerWidth: 620,
      treeData: [],
      treeValue: '0-0-4',
      title: '操作',
      visible: false,
      disableSubmit: false,
      model: {},
      localMenuType: 0,
      locales: window.locales,
      currentLocale: XEUtils.first(XEUtils.filter(window.locales, (item) => item.value == Vue.ls.get('Locale'))),
      dataFilter: false,
      alwaysShow: false, //常に表示、権限設定を無視する
      menuHidden: false, //フォーム要素-ルートを隠し
      routeSwitch: true, //メニューをルートするかどうか
      /*update_begin author:wuxianquan date:20190908 for:変数を定義する。初期値は内部オープン*/
      internalOrExternal: false, //メニューのオープン方
      /*update_end author:wuxianquan date:20190908 for:変数を定義する。初期値は内部オープン*/
      keepAlive: true, //ルートをキャッシュするかどうか
      show: true, // メニューのタイプに応じて、フォーム要素をダイナミックに表示する（表示/隠し）
      isRequrie: true, // 検証するかどうか
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },

      loading: false,
      form: this.$form.createForm(this),

      iconChooseVisible: false,
      validateStatus: '',
    }
  },
  computed: {
    menuLabel: function () {
      if (this.localMenuType == 0) {
        return this.$t('disp.menuType.root') + this.$t('disp.menuName')
      } else if (this.localMenuType == 1) {
        return this.$t('disp.menuType.page') + this.$t('disp.menuName')
      } else {
        return this.$t('disp.menuType.element') + this.$t('disp.menuName')
      }
    },
    parentLabel: function () {
      if (this.localMenuType == 1) {
        return this.$t('disp.parentMenu')
      } else {
        return this.$t('disp.parentPage')
      }
    },
    validatorRules: function () {
      return {
        name: {
          rules: [{ required: true, message: this.$t('disp.rules.require') }, { validator: this.validateName }],
        },
        component: { rules: [{ required: this.show, message: this.$t('disp.rules.require') }] },
        url: { rules: [{ required: this.show, message: this.$t('disp.rules.require') }] },
        // permsType: { rules: [{ required: true, message: '请填写授权策略!' }] },
        sortNo: { initialValue: 1.0 },
        perms: { rules: [{ required: !this.show, message: this.$t('disp.rules.require') }] },
      }
    },
  },
  created() {},
  methods: {
    loadTree() {
      var that = this
      queryTreeList().then((res) => {
        if (res.success) {
          console.log('----queryTreeList---')
          console.log(res)
          that.treeData = []
          let treeList = res.result.treeList
          for (let a = 0; a < treeList.length; a++) {
            let temp = treeList[a]
            temp.isLeaf = temp.leaf
            that.treeData.push(temp)
          }
        }
      })
    },
    edit(record) {
      this.resetScreenSize() // 画面の幅に応じてdrawerの幅を適応的に調整する
      this.form.resetFields()
      this.model = Object.assign({}, record)
      //--------------------------------------------------------------------------------------------------
      //メニューのタイプに応じて、ページフィールドをダイナミックに表示する
      console.log(record)
      this.menuHidden = !record.hidden ? false : true

      if (record.menuType != null) {
        this.localMenuType = this.model.menuType
      }

      if (record.route != null) {
        this.routeSwitch = record.route ? true : false
      }

      if (record.dataFilter != null) {
        this.dataFilter = record.dataFilter ? true : false
      } else {
        this.dataFilter = false
      }

      if (record.keepAlive != null) {
        this.keepAlive = record.keepAlive ? true : false
      } else {
        this.keepAlive = false
      }

      if (record.alwaysShow != null) {
        this.alwaysShow = record.alwaysShow ? true : false
      } else {
        this.alwaysShow = false
      }

      /*update_begin author:wuxianquan date:20190908 for:初期化データを編集する*/
      if (record.internalOrExternal != null) {
        this.internalOrExternal = record.internalOrExternal ? true : false
      } else {
        this.internalOrExternal = false
      }
      /*update_end author:wuxianquan date:20190908 for:初期化データを編集する*/

      //console.log('record.menuType', record.menuType);
      this.show = this.localMenuType == 2 ? false : true
      //----------------------------------------------------------------------------------------------

      this.visible = true
      this.loadTree()
      //let fieldsVal = pick(this.model, 'name', 'perms', 'permsType', 'component', 'url', 'sortNo', 'menuType', 'status')
      let fieldsVal = pick(this.model, 'name', 'perms', 'component', 'url', 'sortNo', 'menuType')
      this.$nextTick(() => {
        this.form.setFieldsValue(fieldsVal)
        //時間フォーマット
        this.form.setFieldsValue({
          startDate: this.model.startDate ? moment(this.model.startDate) : null,
          endDate: this.model.endDate ? moment(this.model.endDate) : null,
        })
      })
    },
    close() {
      this.$emit('close')
      this.disableSubmit = false
      this.visible = false
    },
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      const that = this
      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.model.dataFilter = this.dataFilter
          this.model.alwaysShow = this.alwaysShow
          this.model.hidden = this.menuHidden
          this.model.route = this.routeSwitch
          this.model.keepAlive = this.keepAlive
          /*update_begin author:wuxianquan date:20190908 for:値を取得*/
          this.model.internalOrExternal = this.internalOrExternal
          /*update_end author:wuxianquan date:20190908 for:値を取得*/

          let formData = Object.assign(this.model, values)
          if ((formData.menuType == 1 || formData.menuType == 2) && !formData.parentId) {
            that.validateStatus = 'error'
            that.$message.error('入力したメニュータイプとメッセージを確認してください！')
            return
          } else {
            that.validateStatus = 'success'
          }

          console.log(formData)
          let obj
          if (!this.model.id) {
            obj = addPermission(formData)
          } else {
            obj = editPermission(formData)
          }
          obj
            .then((res) => {
              if (res.success) {
                if (!that.model.id) {
                  that.$message.success(that.$t('msg.insert.success'))
                } else {
                  that.$message.success(that.$t('msg.update.success'))
                }

                that.$emit('ok')
              }
            })
            .finally(() => {
              that.loading = false
              that.close()
            })
        } else {
          that.loading = false
        }
      })
    },
    handleCancel() {
      this.close()
    },
    validateNumber(rule, value, callback) {
      if (!value || new RegExp(/^[0-9]*[1-9][0-9]*$/).test(value)) {
        callback()
      } else {
        callback(this.$t('disp.rules.halfNum'))
      }
    },
    validateName(rule, value, callback) {
      if (this.localMenuType == '2' || !value) {
        callback()
      }

      var params = {
        tableName: 'sys_permission',
        fieldName: 'name',
        fieldVal: value,
        dataId: this.model.id,
      }
      duplicateCheck(params).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback(this.$t('disp.rules.duplicate', [this.$t('disp.menuName')]))
        }
      })
    },
    onChangeMenuType(e) {
      //console.log('localMenuType checked', e.target.value)
      this.localMenuType = e.target.value
      if (e.target.value == 2) {
        this.show = false
      } else {
        this.show = true
      }
      this.$nextTick(() => {
        this.form.validateFieldsAndScroll(['url', 'component'], { force: true })
      })
    },
    selectIcons() {
      this.iconChooseVisible = true
    },
    handleIconCancel() {
      this.iconChooseVisible = false
    },
    handleIconChoose(value) {
      console.log(value)
      this.model.icon = value
      this.form.icon = value
      this.iconChooseVisible = false
    },
    // 画面の幅に応じてdrawerの幅を調整する
    resetScreenSize() {
      let screenWidth = document.body.clientWidth
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth
      } else {
        this.drawerWidth = 620
      }
    },
    handleParentIdChange(value) {
      if (!value) {
        this.validateStatus = 'error'
      } else {
        this.validateStatus = 'success'
      }
    },
  },
}
</script>

<style scoped lang="less">
/deep/ span.ant-radio + * {
  letter-spacing: 0;
}
</style>
